// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Belt__Belt_Option from "melange.belt/belt_Option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Subsonic__SavePlayQueue from "../api/subsonic/savePlayQueue.jsx";

function make(playQueueState) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    const playQueueState$1 = Curry._1(playQueueState, {
      current: state.player.currentSongId,
      currentTime: state.player.currentTime,
      queued: state.player.queuedSongIds
    });
    if (!ReactRouter.deepEqual(playQueueState$1.queued, state.player.queuedSongIds)) {
      store.setState(function (prevState) {
        const init = prevState.player;
        return {
          albums: prevState.albums,
          artists: prevState.artists,
          auth: prevState.auth,
          player: {
            buffered: init.buffered,
            currentSongId: init.currentSongId,
            currentTime: init.currentTime,
            duration: init.duration,
            muted: init.muted,
            paused: init.paused,
            queuedSongIds: playQueueState$1.queued,
            replayGainOptions: init.replayGainOptions,
            volume: init.volume
          },
          songs: prevState.songs
        };
      });
    }
    return Fx.$$catch(Fx.provide(Subsonic__SavePlayQueue.make(playQueueState$1.queued, Belt__Belt_Option.orElse(playQueueState$1.current, state.player.currentSongId), playQueueState$1.currentTime, undefined), {
      credentials: state.auth.credentials
    }), (function (param) {
      return {
        TAG: /* Error */ 1,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* @tanstack/react-router Not a pure module */
